import React from "react";

export default function Base({}) {
	return <>
		<path d="M4.33333 0L0 29L29 33.3333L33.3333 4.33333L4.33333 0ZM33.3333 5.66667L61 0L66.6667 27.6667L39 33.3333L33.3333 5.66667ZM66.6667 3.33333L96.6667 0L100 30L66.6667 33.3333V3.33333ZM1.66667 41.6667L25 35L65 58.3333L8.33333 65L1.66667 41.6667Z"/>
		<path d="M21.6667 21L20.6667 77.3333L76 79.3333L78.6667 22.6667L21.6667 21Z"/>
		<path d="M71.6667 35L68.3333 61.6667L95 65L98.3333 38.3333L71.6667 35ZM0 71.6667L28.3333 66.6667L33.3333 95L5 100L0 71.6667ZM33.3333 70.6667L62.6667 66.6667L66.6667 96L37.3333 100L33.3333 70.6667ZM74 66.6667L66.6667 92.6667L92.6667 100L100 74L74 66.6667Z"/>
	</>
}